<script>
    import R, {LOADER} from "../lib/requests";
    import {formatDate} from "../lib/lib.js";
    import Modal from '../components/modal/Modal.svelte';


    export let closeCallback;

    let data = '';
    let list = null;
    let totalRecords = 0;
    let invalidRecords = 0;
    let batchResult = null;

    const close = (param) => {
        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }

    const onClearData = () => {
        data = '';
    }

    const onClearList = () => {
        list = null;
    }


    const parseData = () => {
        list = null;

        let listData = data.split("\n");
        for (let i = 0; i < listData.length; i++) {
            let line = listData[i].split("\t");

            if (line.length > 3) {
                let date = line[0] ? line[0] : '';
                if (date) {
                    date = formatDate(date.replaceAll("/", "-"), 'y-m-d');
                }
                let mgRecord = {
                    date: date,
                    card_number: line[1] ? line[1].trim() : '',
                    gift_el: line[2] ? line[2].trim() : '',
                    gift_en: line[3] ? line[3].trim() : '',
                    is_valid: true,
                }
                if (!mgRecord.date || !mgRecord.card_number || !mgRecord.gift_el || !mgRecord.gift_en) {
                    mgRecord.is_valid = false;
                }

                if (!list) {
                    list = [];
                }

                list = [...list, mgRecord];
            }
        }

        if (list) {
            totalRecords = list.length;
            invalidRecords = list.filter(x => !x.is_valid).length || 0;
        }
    }

    const save = () => {
        const onSuccess = result => {
            batchResult = result;
            Notifier.showMessage("Το δώρο μέλους ενημερώθηκε");
            close(result);
        }

        const onFailure = err => {
            console.log(err);
        };

        batchResult = null;

        let data = list.filter(x => x.is_valid);

        R.handle(R.membershipGift.batchCreate, {list: data}, onSuccess, onFailure, LOADER.POPUP);
    }
</script>

<Modal title="Εισαγωγή δώρων" modalMd on:close="{ close }">
    <div slot="body">
        <div class="mb-2">
            <img src="/assets/images/gifts-excel-example.jpg" class="img-fluid" alt="excel copy-paste">
        </div>
        <div class="mb-2">
            <textarea class="form-control" bind:value="{ data }" on:change={ parseData }
                      placeholder="επικόλληση δεδομένων από excel"></textarea>
        </div>
        <div class="text-end">
            <button class="btn btn-default" on:click={ onClearData }>Καθαρισμός</button>
        </div>
        {#if list}
            <hr>
            <table class="table table-list table-list-border table-excel mb-2">
                <thead>
                <tr>
                    <th class="px-2">Ημερομηνία</th>
                    <th class="px-2">Αρ. Κάρτας</th>
                    <th class="px-2">Δώρο (Ελληνικά)</th>
                    <th class="px-2">Δώρο (English)</th>
                </tr>
                </thead>
                <tbody>
                {#each list as item}
                    <tr class="row-hover" class:not-valid={ !item.is_valid }>
                        <td class="date-column text-gray p-2">
                            { item.date }
                        </td>
                        <td class="card-column p-2">
                            { item.card_number }
                        </td>
                        <td class="text-gray hidden-xs p-2">
                            { item.gift_el }
                        </td>
                        <td class="text-gray hidden-xs p-2">
                            { item.gift_en }
                        </td>
                    </tr>
                {/each}
                </tbody>
            </table>
            <div class="row">
                <div class="col-xl-8">
                    <div>
                        Σύνολο εγγραφών: { totalRecords }
                    </div>
                    {#if invalidRecords > 0}
                        <div>
                            Εσφαλμένες εγγραφές: { invalidRecords }
                        </div>
                    {/if}
                </div>
                <div class="col-xl-4 text-end">
                    <button class="btn btn-default" on:click={ onClearList }>Καθαρισμός</button>
                </div>
            </div>
        {/if}
        {#if batchResult}
            <div class="alert alert-success mt-3">
                <strong>Η διαδικασία ολοκληρώθηκε.</strong><br>
                Σύνολο εγγραφών: <strong>{ batchResult.count }</strong><br>
                Δημιουργήθηκαν: <strong>{ batchResult.created }</strong>, ενημερώθηκαν :
                <strong>{ batchResult.updated }</strong>, σφάλματα: <strong>{ batchResult.errors }</strong>
            </div>
        {/if}
        <hr>
        <div class="text-end">
            <div class="btn btn-link me-4" on:click="{ () => close() }">Κλείσιμο</div>
            <button class="btn btn-primary px-4" on:click="{ save }"
                    disabled="{ !list || invalidRecords == totalRecords  }">Καταχώρηση
            </button>
        </div>
    </div>
</Modal>

<style>
    .not-valid {
        background: rgba(255, 0, 0, 0.3);
    }

    .table-excel .date-column {
        width: 100px;
    }

    .table-excel .card-column {
        width: 110px;
    }
</style>